function isStaleChunkError(error: Error): boolean {
    const msg = error.message ?? "";
    return msg.includes("Failed to fetch dynamically imported module") || msg.includes("is not a valid JavaScript MIME type") || msg.includes("Importing a module script failed");
}

function getStaleChunkReloadToken(error: Error): string | null {
    if (!isStaleChunkError(error)) {
        return null;
    }

    const matchedUrl = error.message.match(/https?:\/\/[^\s)]+|\/assets\/[^\s)]+/);
    return matchedUrl?.[0] ?? error.message;
}

export { getStaleChunkReloadToken, isStaleChunkError };
